import React, { useEffect, useState } from 'react';
import PaymentsAPI from 'api/PaymentsAPI';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import CircularProgress from '@mui/material/CircularProgress';
import PaymentForm from './PaymentForm';

interface ICreatePaymentModal {
  cusId: string;
  setCreateMode: any;
  paymentSubmit?: string;
  setPaymentSubmit?: any;
}

const CreatePaymentModal: React.FC<ICreatePaymentModal> = ({ cusId, setCreateMode, paymentSubmit, setPaymentSubmit }) => {
  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_API_KEY!);
  const [ stripeOptions, setStripeOptions ] = useState<any>(
    {
      isLoading: true,
      data: {
        clientSecret: '',
        appearance: {
          theme: 'night',
          variables: {
            colorPrimary: '#4895EF',
            colorText: '#EFF1F6',
          }
        }
      }
    });

  const createSetupIntent = async(): Promise<any> => {
    const setupIntentObj = {
      cus_id: cusId
    };
    const res = await PaymentsAPI.createSetupIntent(setupIntentObj);
    if (res?.success) {
      setStripeOptions({ isLoading: false, data: { ...stripeOptions.data, clientSecret: res?.result } });
    }
  };

  useEffect(() => {
    createSetupIntent();
  }, []);

  return (
    <div className='add-method-modal-container'>
      <div className='add-method-modal-header'>
        <div className='add-method-modal-header-content'>
          <div className='add-method-modal-header-icon'>
            <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
              <path d='M22 10H2M22 11V8.2C22 7.0799 22 6.51984 21.782 6.09202C21.5903 5.7157 21.2843 5.40974 20.908 5.21799C20.4802 5 19.9201 5 18.8 5H5.2C4.0799 5 3.51984 5 3.09202 5.21799C2.7157 5.40973 2.40973 5.71569 2.21799 6.09202C2 6.51984 2 7.0799 2 8.2V15.8C2 16.9201 2 17.4802 2.21799 17.908C2.40973 18.2843 2.71569 18.5903 3.09202 18.782C3.51984 19 4.07989 19 5.2 19H11.5M18 21C18 21 21 19.5701 21 17.4252V14.9229L18.8124 14.1412C18.2868 13.9529 17.712 13.9529 17.1864 14.1412L15 14.9229V17.4252C15 19.5701 18 21 18 21Z' stroke='#4895EF' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
            </svg>
          </div>
          <div className='add-method-modal-header-text-group'>
            <div className='add-method-modal-header-text-primary'>
              Add payment method
            </div>
            <div className='add-method-modal-header-text-secondary'>
              Add your payment details.
            </div>
          </div>
        </div>
        <div className='add-method-modal-header-close' onClick={() => setCreateMode(false)}>
          <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
            <path d='M18 6L6 18M6 6L18 18' stroke='#BDBEC1' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
          </svg>
        </div>
      </div>
      {!stripeOptions.isLoading ? (
        <div className='add-method-modal-body'>
          <Elements stripe={stripePromise} options={stripeOptions.data}>
            <PaymentForm setCreateMode={setCreateMode} paymentSubmit={paymentSubmit} setPaymentSubmit={setPaymentSubmit} />
          </Elements>
        </div>
      ) : (
        <div>
          <CircularProgress style={{ color: '#0E8BFF' }} />
        </div>
      )}
    </div>
  );
};

export default CreatePaymentModal;
